import Image from 'next/legacy/image'
import { useTranslation } from 'next-i18next'
import styled, { css } from 'styled-components'

import { breakpoints } from '@/styles'
import useMediaQuery from '@/hooks/use-media-query'

import { Card, Description, Text } from './elements'
import verifiedImageMobile from './images/verified-mobile@3x.png'
import verifiedImage from './images/verified@2x.png'

const marginDesc = css`
  margin-top: 12px;
  @media (max-width: ${breakpoints.phoneMax}) {
    margin: 0;
  }
`

const Wrapper = styled(Card)`
  grid-column: 1 / 2 span;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${breakpoints.phoneMax}) {
    padding-bottom: 30px;
  }
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const ImageWrapper = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 920px;
  width: 100%;

  @media (max-width: ${breakpoints.phoneMax}) {
    width: calc(100% + 50px);
    margin: 0 -25px;
  }
`

const VerifiedListings = () => {
  const { t } = useTranslation('renters')
  const displayMobile = useMediaQuery(`(max-width: ${breakpoints.phoneMax})`)

  return (
    <Wrapper>
      <TextWrapper>
        <Text>{t('renters:Created to protect you')}</Text>
        <Description customStyle={marginDesc}>
          {t(
            'renters:Search from verified listings and landlords, vetted by our extensive verification process.'
          )}
        </Description>
      </TextWrapper>
      <ImageWrapper>
        <Image
          src={displayMobile ? verifiedImageMobile : verifiedImage}
          alt=""
          layout="fill"
          objectFit="contain"
          objectPosition="right center"
          placeholder="blur"
        />
      </ImageWrapper>
    </Wrapper>
  )
}

export default VerifiedListings
